/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class i{static createId(i,s){return`${i}.${s}`}constructor(s,t){this.gridX=s,this.gridY=t,this._indices=[],this.id=i.createId(s,t)}push(i){this._indices.push(i)}}export{i as GridIndexCell};
